export default __webpack_public_path__ + "static/media/1954.dd6a72a5.png";